import { Row, Col, Card, Statistic, Typography } from "antd";
import {
  UserOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";

const { Title } = Typography;

const UserStatsCards = ({ stats }) => (
  <div style={{ paddingBottom: "24px" }}>
    <Title level={4} style={{ marginBottom: "10px", marginTop: "0px" }}>
      User Statistics
    </Title>
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12} md={6}>
        <Card
          hoverable
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderTop: "4px solid #1890ff",
            height: "100%",
          }}
          styles={{
            body: {
              height: "100%",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Statistic
            title={
              <span style={{ fontSize: "16px", color: "#555" }}>
                <UserOutlined
                  style={{ marginRight: "8px", color: "#1890ff" }}
                />
                Total Users
              </span>
            }
            valueRender={() => (
              <CountUp
                end={stats.total}
                duration={2.5}
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "#2c3e50",
                }}
              />
            )}
            style={{ flex: 1 }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card
          hoverable
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderTop: "4px solid #52c41a",
            height: "100%",
          }}
          styles={{
            body: { height: "100%", display: "flex", flexDirection: "column" },
          }}
        >
          <Statistic
            title={
              <span style={{ fontSize: "16px", color: "#555" }}>
                <CheckCircleOutlined
                  style={{ marginRight: "8px", color: "#52c41a" }}
                />
                Active Users
              </span>
            }
            valueRender={() => (
              <CountUp
                end={stats.active}
                duration={2.5}
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "#52c41a",
                }}
              />
            )}
            style={{ flex: 1 }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card
          hoverable
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderTop: "4px solid #f5222d",
            height: "100%",
          }}
          styles={{
            body: {
              height: "100%",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Statistic
            title={
              <span style={{ fontSize: "16px", color: "#555" }}>
                <StopOutlined
                  style={{ marginRight: "8px", color: "#f5222d" }}
                />
                Disabled Users
              </span>
            }
            valueRender={() => (
              <CountUp
                end={stats.disabled}
                duration={2.5}
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "#f5222d",
                }}
              />
            )}
            style={{ flex: 1 }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card
          hoverable
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderTop: "4px solid #faad14",
            height: "100%",
          }}
          styles={{
            body: {
              height: "100%",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Statistic
            title={
              <span style={{ fontSize: "16px", color: "#555" }}>
                <ClockCircleOutlined
                  style={{ marginRight: "8px", color: "#faad14" }}
                />
                Unverified Users
              </span>
            }
            valueRender={() => (
              <CountUp
                end={stats.unverified}
                duration={2.5}
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "#faad14",
                }}
              />
            )}
            style={{ flex: 1 }}
          />
        </Card>
      </Col>
    </Row>
  </div>
);

export default UserStatsCards;